var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"hide-footer":""},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_c('h2',[_vm._v(_vm._s(_vm.title))])]},proxy:true}]),model:{value:(_setup.show),callback:function ($$v) {_setup.show=$$v},expression:"show"}},[_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }